/** Shared cell styles so long text wraps instead of overflowing. */
export const tableCellWrapSx = {
  whiteSpace: "normal",
  wordBreak: "break-word",
  overflowWrap: "anywhere",
};

/** Keep ID cells on one line (overrides tableCellWrapSx). */
export const tableCellNoWrapSx = {
  whiteSpace: "nowrap",
};

/** Shorten Mongo/ObjectIds for table display (last 6 chars). */
export const formatDisplayId = (id) => (id ? `…${String(id).slice(-6)}` : "");

/** Reusable Ant Design column for Mongo _id fields. */
export const idTableColumn = ({ title = "ID", dataIndex = "_id" } = {}) => ({
  title,
  dataIndex,
  render: (value) => formatDisplayId(value),
  onCell: () => ({ style: tableCellNoWrapSx }),
});

/** Ant Design table layout aligned with chainz-partner list pages. */
export const antTableWrapperSx = (isMobile = false, minWidth = 1200) => ({
  width: "100%",
  overflowX: "auto",
  "& .ant-table-wrapper": { width: "100%" },
  "& .ant-table": { minWidth: isMobile ? 300 : minWidth },
  "& .ant-table-cell": tableCellWrapSx,
});

/** Wrap nested Ant tables (e.g. expanded rows) without full wrapper layout. */
export const antTableCellWrapSx = {
  "& .ant-table-cell": tableCellWrapSx,
};

export const muiTableSx = {
  "& .MuiTableCell-root": tableCellWrapSx,
};

export const tableShowTotal = (itemLabel = "items") => (total) =>
  `Total ${total} ${itemLabel}`;

export const defaultPaginatedTableProps = ({
  current,
  pageSize,
  total,
  onChange,
  itemLabel = "items",
  showSizeChanger = false,
}) => ({
  current,
  pageSize,
  total: total ?? 0,
  showSizeChanger,
  showQuickJumper: false,
  showTotal: tableShowTotal(itemLabel),
  onChange,
});
